import { render } from "./VoorPTs.vue?vue&type=template&id=14bbfd94"
import script from "./VoorPTs.vue?vue&type=script&lang=js"
export * from "./VoorPTs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__